const makeConstant = constant => `user/${constant}`

export const SET_NAME = makeConstant('SET_NAME')
export const SET_EMAIL = makeConstant('SET_EMAIL')
export const SET_PASSWORD = makeConstant('SET_PASSWORD')
export const SET_FLOW = makeConstant('SET_FLOW')

export const CHECK_UNIQUE_EMAIL = makeConstant('CHECK_UNIQUE_EMAIL')
export const CHECK_UNIQUE_EMAIL_SUCCESS = makeConstant('CHECK_UNIQUE_EMAIL_SUCCESS')
export const CHECK_UNIQUE_EMAIL_FAILED = makeConstant('CHECK_UNIQUE_EMAIL_FAILED')

export const SET_VALID_EMAIL = makeConstant('SET_VALID_EMAIL')
export const SET_DISABLED_EMAIL = makeConstant('SET_DISABLED_EMAIL')

export const SET_ASSOCIATED_DOMAIN_FOUND = makeConstant('SET_ASSOCIATED_DOMAIN_FOUND')
export const FIND_ASSOCIATED_DOMAIN = makeConstant('FIND_ASSOCIATED_DOMAIN')

export const SET_HIDE_POPUP = makeConstant('SET_HIDE_POPUP')
export const IS_POPUP_HIDDEN = makeConstant('IS_POPUP_HIDDEN')

export const SEND_FIND_MY_TEAM_VERIFICATION_EMAIL = makeConstant('SEND_FIND_MY_TEAM_VERIFICATION_EMAIL')
export const SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_RESET = makeConstant('SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_RESET')
export const SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_SUCCESS = makeConstant('SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_SUCCESS')
export const SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_FAILURE = makeConstant('SEND_FIND_MY_TEAM_VERIFICATION_EMAIL_FAILURE')

export const UPDATE_PASSWORD = makeConstant('UPDATE_PASSWORD')
export const UPDATE_PASSWORD_SUCCESS = makeConstant('UPDATE_PASSWORD_SUCCESS')
export const UPDATE_PASSWORD_PENDING = makeConstant('UPDATE_PASSWORD_PENDING')
export const UPDATE_PASSWORD_FAILED = makeConstant('UPDATE_PASSWORD_FAILED')

export const UPDATE_USER = makeConstant('UPDATE_USER')
export const UPDATE_USER_SUCCESS = makeConstant('UPDATE_USER_SUCCESS')
export const UPDATE_USER_PENDING = makeConstant('UPDATE_USER_PENDING')
export const UPDATE_USER_FAILED = makeConstant('UPDATE_USER_FAILED')

export const UPDATE_USER_AVATAR_SUCCESS = makeConstant('UPDATE_USER_AVATAR_SUCCESS')
export const UPDATE_USER_AVATAR_PENDING = makeConstant('UPDATE_USER_AVATAR_PENDING')
export const UPDATE_USER_AVATAR_FAILED = makeConstant('UPDATE_USER_AVATAR_FAILED')

export const FETCH_USER = makeConstant('FETCH_USER')
export const FETCH_USER_SUCCESS = makeConstant('FETCH_USER_SUCCESS')
export const FETCH_USER_PENDING = makeConstant('FETCH_USER_PENDING')
export const FETCH_USER_FAILED = makeConstant('FETCH_USER_FAILED')

export const FETCH_USER_WITHOUT_NAME = makeConstant('FETCH_USER_WITHOUT_NAME')
export const FETCH_USER_WITHOUT_NAME_SUCCESS = makeConstant('FETCH_USER_WITHOUT_NAME_SUCCESS')
export const FETCH_USER_WITHOUT_NAME_PENDING = makeConstant('FETCH_USER_WITHOUT_NAME_PENDING')
export const FETCH_USER_WITHOUT_NAME_FAILED = makeConstant('FETCH_USER_WITHOUT_NAME_FAILED')

export const FETCH_CLEARBIT_FOR_EMAIL = makeConstant('FETCH_CLEARBIT_FOR_EMAIL')
export const FETCH_CLEARBIT_FOR_EMAIL_SUCCESS = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_SUCCESS')
export const FETCH_CLEARBIT_FOR_EMAIL_PENDING = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_PENDING')
export const FETCH_CLEARBIT_FOR_EMAIL_FAILED = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_FAILED')

export const SET_RESET_TOKEN = makeConstant('SET_RESET_TOKEN')
export const STAGE_PROFILE_PICTURE = makeConstant('STAGE_PROFILE_PICTURE')
export const SET_SSO_PROVISIONED_FLOW = makeConstant('SET_SSO_PROVISIONED_FLOW')
export const SET_AVATAR_URL = makeConstant('SET_AVATAR_URL')

export const UPDATE_USER_PROPERTIES = makeConstant('UPDATE_USER_PROPERTIES')
export const UPDATE_USER_PROPERTIES_SUCCESS = makeConstant('UPDATE_USER_PROPERTIES_SUCCESS')
export const UPDATE_USER_PROPERTIES_PENDING = makeConstant('UPDATE_USER_PROPERTIES_PENDING')
export const UPDATE_USER_PROPERTIES_FAILED = makeConstant('UPDATE_USER_PROPERTIES_FAILED')

export const CHECK_EMAIL_IS_SSO_ENABLED = makeConstant('CHECK_EMAIL_IS_SSO_ENABLED')
export const CHECK_EMAIL_IS_SSO_ENABLED_SUCCESS = makeConstant('CHECK_EMAIL_IS_SSO_ENABLED_SUCCESS')
export const CHECK_EMAIL_IS_SSO_ENABLED_PENDING = makeConstant('CHECK_EMAIL_IS_SSO_ENABLED_PENDING')
export const CHECK_EMAIL_IS_SSO_ENABLED_FAILED = makeConstant('CHECK_EMAIL_IS_SSO_ENABLED_FAILED')

export const GET_LOGIN_URL = makeConstant('GET_LOGIN_URL')
export const GET_LOGIN_URL_SUCCESS = makeConstant('GET_LOGIN_URL_SUCCESS')
export const GET_LOGIN_URL_FAILED = makeConstant('GET_LOGIN_URL_FAILED')

export const SET_IS_CALENDAR_SEAT_ONBOARDING = makeConstant('SET_IS_CALENDAR_SEAT_ONBOARDING')

export const REGISTER_FOR_PUSH_NOTIFICATIONS = makeConstant('REGISTER_FOR_PUSH_NOTIFICATIONS')

export const FETCH_EMAIL_FROM_RELAY = makeConstant('FETCH_EMAIL_FROM_RELAY')
export const FETCH_EMAIL_FROM_RELAY_PENDING = makeConstant('FETCH_EMAIL_FROM_RELAY_PENDING')
export const FETCH_EMAIL_FROM_RELAY_SUCCESS = makeConstant('FETCH_EMAIL_FROM_RELAY_SUCCESS')
export const FETCH_EMAIL_FROM_RELAY_FAILED = makeConstant('FETCH_EMAIL_FROM_RELAY_FAILED')

export const SET_TIMED_VIDEO_GATE_SUCCESS = makeConstant('SET_TIMED_VIDEO_GATE_SUCCESS')
export const SET_TIMED_VIDEO_GATE_PENDING = makeConstant('SET_TIMED_VIDEO_GATE_PENDING')
export const SET_TIMED_VIDEO_GATE_FAILURE = makeConstant('SET_TIMED_VIDEO_GATE_FAILURE')

export const SCHEDULE_NOTIFICATION_REMINDERS = makeConstant('SCHEDULE_NOTIFICATION_REMINDERS')
export const CANCEL_NOTIFICATION_REMINDERS = makeConstant('CANCEL_NOTIFICATION_REMINDERS')

export const urlB64ToUint8Array = function(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}



// WEBPACK FOOTER //
// ./src/modules/user/constants.js